import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './slide.css';
import { IFotoramaData } from '../../../../../typings/fotorama';
import { VideoContainer } from '../video/video';
import { PlayerState } from '../youtube';

export type SlideStatus = 'pending' | 'video' | 'loaded' | 'errored' | 'html';

export type SlideSource = {
  status: SlideStatus;
  slide: IFotoramaData;
  content?: React.ReactNode;
  onPlayerStateChange?(state: PlayerState): void;
};

export interface ISlideProps {
  source: SlideSource;
  noInterface?: boolean;
  contentRef?(node: HTMLImageElement | HTMLDivElement | null): void;
}

export class Slide extends React.PureComponent<ISlideProps, object> {
  public render() {
    const { source, noInterface } = this.props;

    // tslint:disable-next-line:switch-default
    switch (source.status) {
      case 'video':
        return (
          <div className={styles['wrapper']} ref={this.props.contentRef}>
            <VideoContainer
              video={source.slide.video as string}
              styles={styles['video_slide']}
              iframeStyles={mergeStyles(styles['iframe'], noInterface && styles['no_interface']).className}
              previewStyles={mergeStyles(styles['preview'], noInterface && styles['no_interface']).className}
              hideCloseButton={!noInterface}
              onPlayerStateChange={e => source.onPlayerStateChange && source.onPlayerStateChange(e)}
            />
          </div>
        );

      case 'pending':
        return <div>preloader</div>;

      case 'loaded':
        return (
          <div className={styles['wrapper']}>
            <img className={styles['slide']} src={source.slide.img} ref={this.props.contentRef} />
          </div>
        );

      case 'html':
        return (
          <div className={styles['wrapper']} ref={this.props.contentRef}>
            {source.content}
          </div>
        );

      case 'errored':
        return <div>error</div>;
    }
  }
}
